import styled from "styled-components";

export const PageContainerStyle = styled.div`
     

    width: 100%;    
    background-color: var(--branco);    
    border-radius: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    box-shadow: 1px 1px 5px var(--preto-primario2);
    overflow: hidden;
`;
